import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Card, SectionHeader, CheckBox } from '../common';

export default function PaymentAgreementCard({ onAllAgreedChange }) {
  const { t } = useTranslation();
  // Row 28: 결제 약관 — 개인정보 "처리방침"은 동의 항목 아님 (정책 안내용, footer 링크로 충분)
  // age14 → service(이용약관) → privacyConsent(수집·이용 동의) → refund → marketing(선택)
  const PAYMENT_TERMS = [
    { id: 'age14', label: t('common.age_14_or_above'), slug: null, required: true },
    { id: 'service', label: t('common.service_terms'), slug: 'service', required: true },
    { id: 'privacyConsent', label: t('common.privacy_consent'), slug: 'privacyConsent', required: true },
    { id: 'refund', label: t('common.refund_policy'), slug: 'refund', required: true },
    { id: 'marketing', label: t('footer.marketing'), slug: 'marketing', required: false },
  ];

  const [checked, setChecked] = useState(
    Object.fromEntries(PAYMENT_TERMS.map((tt) => [tt.id, false]))
  );

  const allChecked = PAYMENT_TERMS.every((tt) => checked[tt.id]);
  const allRequiredChecked = PAYMENT_TERMS.filter((tt) => tt.required).every((tt) => checked[tt.id]);

  useEffect(() => {
    onAllAgreedChange?.(allRequiredChecked);
  }, [allRequiredChecked, onAllAgreedChange]);

  const handleToggleAll = () => {
    const next = !allChecked;
    setChecked(Object.fromEntries(PAYMENT_TERMS.map((tt) => [tt.id, next])));
  };

  const handleToggle = (id) => {
    setChecked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <Card>
      <SectionHeader variant="card" title={t('common.agreement')} />
      <CheckBox label={t('common.all_agree')} checked={allChecked} onChange={handleToggleAll} />
      <div className="border-t border-mono-100 pt-3 space-y-3">
        {PAYMENT_TERMS.map((term) => (
          <div key={term.id} className="flex items-center justify-between">
            {/* BugHerd #131: [필수]/[선택] 텍스트 prefix 폐기 → CheckBox 의 required/optional prop 으로
                별표(*) / 회색 "(선택)" 인라인 노출. "전체 동의"(상단) 는 표기 없음 — 원본 요청과 일치. */}
            <CheckBox
              label={term.label}
              required={term.required}
              optional={!term.required}
              checked={checked[term.id]}
              onChange={() => handleToggle(term.id)}
            />
            {term.slug ? (
              <a href={`/policy/${term.slug}`} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className="shrink-0 p-1 text-mono-400 hover:text-mono-600 transition">
                <Icon name="chevron-right" size={16} />
              </a>
            ) : (
              <span className="w-6" />
            )}
          </div>
        ))}
      </div>
    </Card>
  );
}
